import React, {useState} from 'react';

const ParseJsonTree = ({values, iteration = 1, isArray = false}) => {
	const [show] = useState(true);

	if (!values || Object.values(values).length === 0) return '';
	if (typeof values === 'string') {
		isArray = true;
		values = [values];
	}

	const style = {paddingLeft: 20, width: '100%'};
	const data = Object.entries(values);
	const first = iteration === 1;

	const findTypeValue = (value) => {
		if (value === '') return '<span class="emptyString">""</span>';
		if (value === '[]') return '[]';
		if (value === '{}') return '{}';
		if (value === null) return `<span class="boolean font-weight-bold">${null}</span>`;
		if (value === undefined) return `<span class="boolean font-weight-bold">${undefined}</span>`;

		switch (typeof value) {
			case 'boolean': return `<span class="boolean font-weight-bold">${Boolean(value)}</span>`;
			case 'string': return `<span class="text">"${value}"</span>`;
			case 'number': return `<span class="number">${value}</span>`;
			default: return value
		}
	};

	const firstIter = (data) => {
		return (
			<ul className="parseJsonTree">
				<li>{'{'}</li>
				<li>{data}</li>
				<li>{'}'}</li>
			</ul>
		);
	};

	const renderIsValue = (key, value) => {
		return (
			<li style={style}>{!isArray ? <span><span className="key">"{key}"</span>:</span>: ''} <span dangerouslySetInnerHTML={{ __html: findTypeValue(value) }}/>,</li>
		)
	};
	const renderIsArray = (key, value) => {
		if (value === null) return renderIsValue(key, null);
		if (value === undefined) return renderIsValue(key, undefined);
		if (value.length === 0) return renderIsValue(key, '[]');

		const renderObjectF = () => show ? '[' : `[${value.length}]`;

		return (
			<ul style={style}>
				<li><span><span className="key">"{key}"</span>:</span> {renderObjectF()}</li>
				<li><ParseJsonTree isArray = {true} iteration={++iteration} values={value}/></li>
				<li>{'],'}</li>
			</ul>
		)
	};
	const renderIsObject = (key, value) => {
		if (value === null) return renderIsValue(key, null);
		if (value === undefined) return renderIsValue(key, undefined);
		if (Object.values(value).length === 0) return renderIsValue(key, '{}');

		const renderObjectF = () => show ? '{' : `{${Object.values(value).length}}`;
		return (
			<ul style={style}>
				<li>{!isArray ? <span><span className="key">"{key}"</span>:</span>: ''} {renderObjectF()}</li>
				<li><ParseJsonTree iteration={++iteration} values={value}/></li>
				<li>{'},'}</li>
			</ul>
		)
	};

	const result = data.map(([key, value]) => {
		if (Array.isArray(value)) {
			return renderIsArray(key, value)
		} else if (typeof value === 'object') {
			return renderIsObject(key, value);
		}

		return renderIsValue(key, value);
	});

	return first ? firstIter(result) : result;
};

export default ParseJsonTree;
